import { ApiProperty } from "@nestjs/swagger";

export class PlantIdRequest {
    @ApiProperty()
    unitcodeId:number
}